import almostHome from '../../assets/localsImg/almostHome.jpg';
import bridges from '../../assets/localsImg/bridges.jpg';
import tacoWapo from '../../assets/localsImg/tacoWapo.jpg';
import blushing from '../../assets/localsImg/blushing.jpg';
import bodega from '../../assets/localsImg/bodega.jpg';
import breadworks from '../../assets/localsImg/breadworks.jpg';
import brittsBloming from '../../assets/localsImg/brittsBloming.jpg';
import moores from '../../assets/localsImg/moores.jpg';
import conspire from '../../assets/localsImg/conspire.jpg';
import donJulio from '../../assets/localsImg/donJulio.jpg';
import flutteringDuck from '../../assets/localsImg/flutteringDuck.jpg';
import lostHollow from '../../assets/localsImg/lostHollow.jpg';
import marvins from '../../assets/localsImg/marvins.jpg';
import burdgeBoots from '../../assets/localsImg/burdgeBoots.jpg';
import scoops from '../../assets/localsImg/scoops.jpg';
import silverBell from '../../assets/localsImg/silverBell.jpg';
import tapHouse from '../../assets/localsImg/tapHouse.jpg';
import theWhisk from '../../assets/localsImg/theWhisk.jpg';

const LocalsData = [
  {
    image: conspire,
    name: "Conspire Contemporary Craft",
    lat: 39.643915721869355,
    lng: -86.86385053321543,
    shortDescription: "Handmade art, gifts, and local crafts in a cozy space.",
    rating: 4.9,
    address: "14 E Washington St, Greencastle, IN 46135",
    mapURL: "https://maps.app.goo.gl/MAfhkcaEex5pkzR27",
    website: "http://www.conspireindiana.com/",
    tel: "+1 (765)-719-2476",
    hours: {
      Monday: "Closed",
      Tuesday: "11:00–18:00",
      Wednesday: "11:00–18:00",
      Thursday: "11:00–18:00",
      Friday: "11:00–18:00",
      Saturday: "10:00–17:00",
      Sunday: "Closed"
    }
  },
  {
    image: silverBell,
    name: "Silver Bell Flowers",
    lat: 39.643564309305845,
    lng:  -86.86313110664017,
    shortDescription: "Charming flower shop offering bouquets and custom arrangements.",
    rating: 5.00,
    address: "17 S Vine St, Greencastle, IN 46135",
    mapURL: "https://maps.app.goo.gl/XpZYGL6MTJGHct7w9",
    website: "https://www.silverbellflowers.com/",
    tel: "+1 (765)-630-8115",
    hours: {
      Monday: "09:30–16:00",
      Tuesday: "09:30–16:00",
      Wednesday: "09:30–16:00",
      Thursday: "09:30–16:00",
      Friday: "09:30–16:00",
      Saturday: "Closed",
      Sunday: "Closed"
    }
  },
  {
    image: tapHouse,
    name: "TapHouse Burgers",
    lat: 39.643383598605915,
    lng:  -86.86472930219064,
    shortDescription: "Casual spot for gourmet burgers and craft beer.",
    rating: 4.2,
    address: "24 S Indiana St, Greencastle, IN 46135",
    mapURL: "https://maps.app.goo.gl/nAycjuRMmPrkkWrF8",
    website: "http://taphouseburgers.com/",
    tel: "+1 (765)-301-9326",
    hours: {
      Monday: "Closed",
      Tuesday: "Closed",
      Wednesday: "12:00–19:00",
      Thursday: "12:00–19:00",
      Friday: "12:00–21:00",
      Saturday: "12:00–21:00",
      Sunday: "12:00–19:00"
    }
  },
  {
    image: brittsBloming,
    name: "Britt’s Blooming Boutique",
    lat: 39.64345264354609,
    lng:  -86.86426042920606,
    shortDescription: "Trendy boutique for women’s fashion and accessories.",
    rating: 5.0,
    address: "21 S Indiana St, Greencastle, IN 46135",
    mapURL: "https://maps.app.goo.gl/1DE9KAFNK9CLCson9",
    website: "http://www.brittsbloomingboutique.com/",
    tel: "+1 (765)-301-9213",
    hours: {
      Monday: "11:00–17:00",
      Tuesday: "11:00–17:00",
      Wednesday: "11:00–17:00",
      Thursday: "11:00–17:00",
      Friday: "11:00–17:00",
      Saturday: "11:00–18:00",
      Sunday: "Closed"
    }
  },
  {
    image: flutteringDuck,
    name: "The Fluttering Duck",
    lat: 39.641692100473485,
    lng:  -86.86360647714814,
    shortDescription: "Upscale pub food inside the Inn at DePauw.",
    rating: 4.1,
    address: "2 W Seminary St, Greencastle, IN 46135",
    mapURL: "https://maps.app.goo.gl/LmovPKGjiYQsAF5KA",
    website: "https://www.innatdepauw.com/dining?_gl=1*4l1dxn*_up*MQ..*_ga*MjEwMDAzMTQ3LjE3NDM2NTQ2NzA.*_ga_ZQVD2RT05W*MTc0MzY1NDY2OS4xLjAuMTc0MzY1NDY2OS4wLjAuMA..#THEFLUTTERINGDUCK",
    tel: "+1 (765)-658-1000",
    hours: {
      Monday: "11:00–22:00",
      Tuesday: "11:00–22:00",
      Wednesday: "11:00–22:00",
      Thursday: "11:00–22:00",
      Friday: "11:00–22:00",
      Saturday: "12:00–22:00",
      Sunday: "Closed"
    }
  },
  {
    image: burdgeBoots,
    name: "Burdge Boots & Boutique",
    lat: 39.643099152465325,
    lng: -86.86558434156458,
    shortDescription: "Boots, western wear, and fashion-forward finds.",
    rating: 4.9,
    address: "100 W Walnut St, Greencastle, IN 46135",
    mapURL: "https://maps.app.goo.gl/B5gm4LNEUwY1xiCc8",
    website: "http://burdgeboots.com/",
    tel: "+1 (765)-630-8247",
    hours: {
      Monday: "Closed",
      Tuesday: "11:00–18:00",
      Wednesday: "11:00–18:00",
      Thursday: "11:00–18:00",
      Friday: "11:00–17:00",
      Saturday: "12:00–22:00",
      Sunday: "Closed"
    }
  },
  {
    image: almostHome,
    name: "Almost Home",
    lat: 39.64494278603445,
    lng: -86.8651023541528,
    shortDescription: "Homestyle American restaurant known for comfort food.",
    rating: 4.3,
    address: "17 W Franklin St, Greencastle, IN 46135",
    mapURL: "https://maps.app.goo.gl/u6nYo9EeqhgSFgpr6",
    website: "http://www.almosthomerestaurant.com/",
    tel: "+1 (765)-653-5788",
    hours: {
      Monday: "11:00–20:00",
      Tuesday: "11:00–15:00",
      Wednesday: "11:00–15:00",
      Thursday: "11:00–20:00",
      Friday: "11:00–21:00",
      Saturday: "11:00–21:00",
      Sunday: "11:00–15:00"
    }
  },
  {
    image: tacoWapo,
    name: "Taco Wapo",
    lat: 39.64375015067762,
    lng: -86.86104431704884,
    shortDescription: "Local taco spot serving Mexican street food.",
    rating: 4.7,
    address: "306 E Washington St, Greencastle, IN 46135",
    mapURL: "https://maps.app.goo.gl/apUZvVrCaE68EjzE8",
    website: "",
    tel: "+1 (765)-653-0169",
    hours: {
      Monday: "Closed",
      Tuesday: "11:00–21:00",
      Wednesday: "11:00–21:00",
      Thursday: "11:00–21:00",
      Friday: "11:00–21:00",
      Saturday: "11:00–21:00",
      Sunday: "11:00–21:00"
    }
  },
  {
    image: donJulio,
    name: "Don Julio",
    lat: 39.644858605334456,
    lng:  -86.86488585657182,
    shortDescription: "Colorful Mexican restaurant offering margaritas & classics.",
    rating: 4.5,
    address: "11 W Franklin St, Greencastle, IN 46135",
    mapURL: "https://maps.app.goo.gl/F5cEgrRriGbPVESCA",
    website: "",
    tel: "+1 (765)-630-8525",
    hours: {
      Monday: "11:00–21:00",
      Tuesday: "11:00–21:00",
      Wednesday: "11:00–21:00",
      Thursday: "11:00–21:00",
      Friday: "11:00–22:00",
      Saturday: "11:00–22:00",
      Sunday: "11:00–21:00"
    }
  },
  {
    image: lostHollow,
    name: "Lost Hollow",
    lat: 39.64455395611986,
    lng: -86.86331773640174,
    shortDescription: "Craft beer, good food & live music.",
    rating: 4.5,
    address: "102 E Franklin St, Greencastle, IN 46135",
    mapURL: "https://maps.app.goo.gl/LaCwJTW9vd1jy2nHA",
    website: "http://losthollowbeerco.com/",
    tel: "+1 (765)-655-0115",
    hours: {
      Monday: "Closed",
      Tuesday: "Closed",
      Wednesday: "11:00–21:00",
      Thursday: "11:00–21:00",
      Friday: "11:00–21:00",
      Saturday: "11:00–21:00",
      Sunday: "Closed"
    }
  },
  {
    image: marvins,
    name: "Marvin’s",
    lat: 39.642345090643566,
    lng: -86.86273791145601,
    shortDescription: "DePauw late-night legend with garlic cheeseburgers.",
    rating: 4.1,
    address: "202 S College Ave, Greencastle, IN 46135",
    mapURL: "https://maps.app.goo.gl/k6YX6arxKDijRsJP9",
    website: "",
    tel: "+1 (765)-653-9200",
    hours: {
      Monday: "Closed",
      Tuesday: "11:00-14:00 17:00-22:00",
      Wednesday: "11:00-14:00 17:00-22:00",
      Thursday: "11:00-14:00 17:00-22:00",
      Friday: "11:00-14:00 17:00-00:00",
      Saturday: "17:00-00:00",
      Sunday: "17:00-22:00"
    }
  },
  {
    image: blushing,
    name: "Blushing Beaus Boutique",
    lat: 39.643900599625,
    lng: -86.86470009441732,
    shortDescription: "Trendy clothing and gift boutique downtown.",
    rating: 5.0,
    address: "8 W Washington St, Greencastle, IN 46135",
    mapURL: "https://maps.app.goo.gl/TvcFgTQgTyGvMr5M8",
    website: "http://www.blushingbeausboutique.com/",
    tel: "+1 (765)-276-3145",
    hours: {
      Monday: "Closed",
      Tuesday: "11:00-17:00",
      Wednesday: "11:00-17:00",
      Thursday: "11:00-17:00",
      Friday: "11:00-17:00",
      Saturday: "10:00-17:00",
      Sunday: "Closed",
    }
  },
  // {
  //   image: img1,
  //   name: "Antiques & Collectibles",
  //   lat: 39.6414,
  //   lng: -86.8611,
  //   shortDescription: "Vintage treasures and timeless décor finds.",
  //   rating: 4.2,
  //   address: "25 W Washington St, Greencastle, IN 46135"
  // },

  // https://maps.app.goo.gl/f7yoSBHXdcPCuJ3v6


  {
    image: theWhisk,
    name: "The Whisk",
    lat: 39.64365308023032,
    lng: -86.86554221209343,
    shortDescription: "Bakery and café with espresso & pastries.",
    rating: 4.9,
    address: "18 S Jackson St, Greencastle, IN 46135",
    mapURL: "https://maps.app.goo.gl/zib4JP4UtZYzCYgT7",
    website: "http://www.thewhiskgreencastle.com/",
    tel: "+1 (765)-653-6700",
    hours: {
      Monday: "Closed",
      Tuesday: "Closed",
      Wednesday: "Closed",
      Thursday: "17:00-21:00",
      Friday: "17:00-22:00",
      Saturday: "10:00-14:00",
      Sunday: "10:00-14:00",
    }
  },
  {
    image: bodega,
    name: "The Bodega",
    lat: 39.64373053658851,
    lng:  -86.8656718785607,
    shortDescription: "Local market with snacks, drinks, and essentials.",
    rating: 5.0,
    address: "16 S Jackson St, Greencastle, IN 46135",
    mapURL: "https://maps.app.goo.gl/QYjF4uBYZASJZECw9",
    website: "",
    tel: "+1 (765)-653-6060",
    hours: {
      Monday: "07:00-14:00",
      Tuesday: "07:00-14:00",
      Wednesday: "07:00-14:00",
      Thursday: "07:00-14:00",
      Friday: "07:00-14:00",
      Saturday: "09:00-14:00",
      Sunday: "Closed",
    }
  },
  {
    image: scoops,
    name: "Scoops Ice Cream Parlor",
    lat: 39.64366801488559,
    lng: -86.86435123154759,
    shortDescription: "Local favorite for hand-dipped ice cream.",
    rating: 4.8,
    address: "13 S Indiana St, Greencastle, IN 46135",
    mapURL: "https://maps.app.goo.gl/ekRVW7abA8XbBnZJ8",
    website: "",
    tel: "+1 (765)-323-8903",
    hours: {
      Monday: "12:00-21:00",
      Tuesday: "12:00-21:00",
      Wednesday: "12:00-21:00",
      Thursday: "12:00-21:00",
      Friday: "12:00-21:00",
      Saturday: "12:00-21:00",
      Sunday: "12:00-21:00",
    }
  },
  {
    image: breadworks,
    name: "Breadworks By Bridges",
    lat: 39.64314088475463,
    lng:  -86.86431975802495,
    shortDescription: "Artisan bread and pastries made fresh daily.",
    rating: 4.3,
    address: "2 E Walnut St, Greencastle, IN 46135",
    mapURL: "https://maps.app.goo.gl/uBgjysQ5hdpqPzJs8",
    website: "https://breadworksbybridges.com/",
    tel: "+1 (765)-630-8890",
    hours: {
      Monday: "Closed",
      Tuesday: "07:00-15:00",
      Wednesday: "07:00-15:00",
      Thursday: "07:00-15:00",
      Friday: "07:00-15:00",
      Saturday: "08:00-15:00",
      Sunday: "08:00-15:00",
    }
  },
  {
    image: bridges,
    name: "Bridges Craft Pizza & Wine Bar",
    lat: 39.64449504491711,
    lng: -86.86422249524844,
    shortDescription: "Wood-fired pizza and wine in a stylish rooftop setting.",
    rating: 4.5,
    address: "19 N Indiana St, Greencastle, IN 46135",
    mapURL: "https://maps.app.goo.gl/X23DQqwjMzgBSz6f9",
    website: "https://www.bridgeswinebar.com/",
    tel: "+1 (765)-653-0021",
    hours: {
      Monday: "Closed",
      Tuesday: "17:00-20:00",
      Wednesday: "17:00-20:00",
      Thursday: "17:00-20:00",
      Friday: "17:00-21:00",
      Saturday: "17:00-21:00",
      Sunday: "Closed",
    }
  },
  {
    image: moores,
    name: "Moores Bar & Restaurant",
    lat: 39.643529460290125,
    lng: -86.86435385857934,
    shortDescription: "Classic American bar with burgers, brews, and live music.",
    rating: 4.4,
    address: "17 S Indiana St, Greencastle, IN 46135",
    mapURL: "https://maps.app.goo.gl/tLbM4icNTxCkQbAY9",
    website: "http://mooresbarandgrill.com/",
    tel: "+1 (765)-653-9939",
    hours: {
      Monday: "11:00-1:00",
      Tuesday: "11:00-1:00",
      Wednesday: "11:00-1:00",
      Thursday: "11:00-1:00",
      Friday: "11:00-1:00",
      Saturday: "11:00-1:00",
      Sunday: "Closed",
    }
  }
];

export default LocalsData;
